module.exports = __webpack_public_path__ + "static/media/a756f1b3-9f97-41b5-9e27-18d809b02757.0d67b8d0.JPG";